import {
    OPTIONAL_SURVEY_FETCH_SUCCESS,
    ReduxAction,
} from '../actions/surveyTypes';
import { Survey } from '../model/models';

const optionalSurveyState = (
    state: Survey = {
        domains: [],
        domainCursor: 0,
        presurveyCompleted: false,
        userInfos: {
            lastAnsweredTime: 0,
            gdprAccepted: null,
            surveyCompleted: null,
            moreInfo: {},
            mandatoryDomainsCompleted: false,
            optionalDomainSelected: false,
        },
    },
    action: ReduxAction,
): Survey => {
    switch (action.type) {
        case OPTIONAL_SURVEY_FETCH_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default optionalSurveyState;